import type { CategoriaComContrato } from '../types';

const CATEGORIAS: Record<CategoriaComContrato, CategoriaComContrato> = {
  NOTIFICACAO: 'NOTIFICACAO',
  NEGOCIACAO: 'NEGOCIACAO',
  ARBITRAGEM: 'ARBITRAGEM',
};

export const CATEGORIAS_COM_CONTRATO: readonly CategoriaComContrato[] = Object.values(CATEGORIAS);
